import classNames from 'classnames';

import Swiper, { SwiperSlide } from '@/components/common/Swiper';
import PLACEHOLDER_LOGO from '@/assets/images/logo/weee-placeholder-logo.png';
import styles from './index.module.scss';
import { twMerge } from 'tailwind-merge';

export default function CarouselSkeleton({ version }: { version?: string }) {
  const isV4Banner = version === 'v4';

  return (
    <div className={classNames(styles.bannerWrap, styles.bannerWrapSkeleton, { [styles.bannerWrapV4]: isV4Banner })}>
      <div className={classNames(styles.bannerWrap_swiper, { [styles.bannerWrap_swiperV4]: isV4Banner })}>
        <Swiper
          spaceBetween={0}
          resistanceRatio={0}
          slidesPerView={'auto'}
          centeredSlides
          breakpoints={{
            // 当屏幕宽度 <= 750px 时启用居中
            750: {
              centeredSlides: false
            }
          }}>
          {new Array(3).fill(0).map((item, index) => {
            return (
              <SwiperSlide key={`banner-${index}`}>
                <div className={styles.bannerWrap_link}>
                  <div
                    className={twMerge(
                      styles.img,
                      'flex justify-center items-center box-border border border-solid border-[rgba(0,25,88,0.08)]'
                    )}>
                    <div
                      className="w-full h-full"
                      style={{
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundImage: `url(${PLACEHOLDER_LOGO})`,
                        backgroundSize: '105px 31.5px'
                      }}
                    />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
